/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import RegimenAdverseEvent from './regimen-adverse-event';
import RegimenAdverseEventDetail from './regimen-adverse-event-detail';
import RegimenAdverseEventUpdate from './regimen-adverse-event-update';
import RegimenAdverseEventDeleteDialog from './regimen-adverse-event-delete-dialog';

const RegimenAdverseEventRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<RegimenAdverseEvent />} />
    <Route path="new" element={<RegimenAdverseEventUpdate />} />
    <Route path=":id">
      <Route index element={<RegimenAdverseEventDetail />} />
      <Route path="edit" element={<RegimenAdverseEventUpdate />} />
      <Route path="delete" element={<RegimenAdverseEventDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RegimenAdverseEventRoutes;
